module.exports = __webpack_public_path__ + "static/img/wesite.c37e670.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wesite.png
// module id = w16+
// module chunks = 3